"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagCloseButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _buttonResetMixin = require("../buttonResetMixin");
var TagCloseButtonMixin = function TagCloseButtonMixin(props) {
  return (0, _styledToken.default)({
    focusBoxShadow: 'Tag.closeButton.boxShadow.focus',
    hoverOpacity: 'Tag.closeButton.opacity.hover',
    activeOpacity: 'Tag.closeButton.opacity.active',
    targetPadding: 'Tag.targetPadding',
    borderRadius: 'Tag.closeButton.borderRadius',
    lineHeight: 'Tag.closeButtonSize'
  }, function (_ref) {
    var focusBoxShadow = _ref.focusBoxShadow,
      hoverOpacity = _ref.hoverOpacity,
      activeOpacity = _ref.activeOpacity,
      targetPadding = _ref.targetPadding,
      borderRadius = _ref.borderRadius,
      lineHeight = _ref.lineHeight;
    return (0, _styledComponents.css)(["", " padding:", "px;margin:-", "px;line-height:", "px;transition:opacity 0.15s ease;&:hover{opacity:", ";}&:active{opacity:", ";}outline:none;&:focus ", "{border-radius:", ";box-shadow:", ";}"], (0, _buttonResetMixin.buttonResetMixin)(props), targetPadding, targetPadding, lineHeight, hoverOpacity, activeOpacity, _Icon.StyledIcon, borderRadius, focusBoxShadow);
  })(props);
};
exports.TagCloseButtonMixin = TagCloseButtonMixin;